import { Mail } from "lucide-react";

export default function ContactFab() {
  return (
    <a
      href="mailto:educarte1000@gmail.com?subject=Contato%20EDUCARTE"
      data-testid="contact-fab"
      title="Fale conosco: educarte1000@gmail.com"
      className="group fixed bottom-6 right-6 z-50 flex items-center gap-0 rounded-full bg-brand-blue text-white shadow-xl shadow-brand-blue/30 hover:bg-blue-700 transition-all duration-300 h-14 pl-4 pr-4 hover:pr-5"
    >
      <Mail className="w-6 h-6 shrink-0" />
      <span className="max-w-0 overflow-hidden whitespace-nowrap opacity-0 group-hover:max-w-xs group-hover:opacity-100 group-hover:ml-2.5 transition-all duration-300 font-semibold text-sm">
        Fale conosco · educarte1000@gmail.com
      </span>
    </a>
  );
}
